<template>
  <div class="document-embedder">
    <div class="document-embedder__link" @click="toggleDocument">
      <span class="document-embedder__name">
        {{ fileName }} {{ fileSize ? `(${fileSize})` : '' }}
      </span>
      <button
          class="buy-product__action"
          :class="showDocument ? 'is-open' : 'is-show'"
          @click.stop="toggleDocument"
      >
        {{ showDocument ? 'Close' : 'Show' }}
      </button>
    </div>

    <div v-if="showDocument" class="document-embedder__iframe-wrapper">
      <iframe
          v-if="fileUrl"
          :src="fileUrl"
          class="document-embedder__iframe"
          frameborder="0"
          allowfullscreen
      ></iframe>
      <div v-else class="document-embedder__placeholder">
        Datei konnte nicht geladen werden.
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';

const props = defineProps<{
  fileUrl: string,
  fileSize: string,
  fileName: string,
}>();

const showDocument = ref(false);

const toggleDocument = () => {
  showDocument.value = !showDocument.value;
};
</script>

<style lang="scss">
@use "~/common/scss/button";
@use "~/common/scss/variables";

.document-embedder {
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  &__link {
    align-items: center;
    border: 1px solid variables.$colorGreyBorder;
    border-radius: 4px;
    display: flex;
    justify-content: space-between;
    padding: 1rem 1.5rem;
    width: 100%;
    cursor: pointer;
  }

  &__name {
    grid-area: name;
  }

  &__iframe-wrapper {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  &__iframe {
    width: 100%;
    height: 600px;
    border: 1px solid variables.$colorGreyBorder;
    border-radius: 4px;
  }
}

.buy-product__action {
  &.is-show {
    @include button.buttonOrange();
    @include button.buttonMedium();

    background-color: variables.$colorOrange !important;
    border-color: variables.$colorOrange !important;
    color: #fff !important;
  }

  &.is-open {
    background-color: transparent !important;
    border-color: variables.$colorOrange !important;
    color: variables.$colorOrange !important;
  }

  transition: background-color 0.25s ease, color 0.25s ease, border-color 0.25s ease;
}

</style>